export default "__VITE_ASSET__DxFm4O5V__"